export default "__VITE_ASSET__DJXnCNme__"